export const KEAP_SMS_COMPLIANCE_URL = 'https://www.keap.com/legal/sms-compliance';

export const TOLL_FREE_MESSAGE_VERIFICATION_URL = 'https://help.infusionsoft.com/help/toll-free-message-verification';

export const KEAP_PROVIDED_OPT_IN_IMAGE_URL = 'https://docs.google.com/document/d/1f00H7QDsl8C13mCD4jpz95jBuWs4R3bn-G_izNpb2cA/edit';

export const SOURCES = {
    BROADCAST: 'broadcast',
    AUTOMATION: 'automation',
};

export const SMS_WIZARD_STAGE = {
    WRITE: 0,
    SEND: 1,
};

export const MESSAGE_CONSTANTS = {
    TEXT: 'Text message',
    SENT: 'Sent',
    PENDING: 'Pending opt-in',
    UNSUBSCRIBED: 'Unsubscribed',
    BROADCAST_SENDING_MESSAGE: 'Sending now',
    BROADCAST_ERROR_MESSAGE: 'This broadcast encountered an error',
    SEARCH: 'Search text message broadcasts',
    ERROR_LOADING: 'There was an error loading your SMS broadcasts',
    BROADCAST_DELETE_ERROR: 'Sorry, we cannot delete this broadcast',
    BROADCAST_STOP_ERROR: 'Sorry, we cannot stop this broadcast',
    BROADCAST_RESUME_ERROR: 'Sorry, we cannot resume this broadcast',
    BROADCAST_STOP_SUCCESS: 'Broadcast stopped successfully',
    BROADCAST_DELETE_SUCCESS: 'Broadcast deleted successfully',
    BROADCAST_RESUME_SUCCESS: 'Broadcast resumed successfully',
    DELETE_CONFIRM_TITLE: 'Delete draft?',
    DELETE_CONFIRM_MESSAGE: 'Deleting this draft will remove it permanently.',
    DELETE_CONFIRM_BUTTON_TEXT: 'Delete draft',
    DELETE_CANCEL_BUTTON_TEXT: 'Go back',
};

export const SMS_BROADCAST_STATUS = {
    SCHEDULED: 'SCHEDULED',
    SENDING: 'SENDING',
    SENT: 'SENT',
    DRAFT: 'DRAFT',
    STOPPED: 'STOPPED',
    ERROR: 'FAILURE',
};

export const STAGE_STATUS = {
    IN_PROGRESS: 'inProgress',
    COMPLETE: 'complete',
    INVALID: 'invalid',
};

export const SMS_BROADCAST_STATUS_MESSAGE = {
    SCHEDULED: 'Scheduled',
    SENDING: 'Sending',
    SENT: 'Sent',
    DRAFT: 'Draft',
    STOPPED: 'Stopped',
    FAILURE: 'Failure',
};

export const SMS_BROADCAST_STATUS_INDICATOR_MESSAGE = {
    SCHEDULED: 'Scheduled by user',
    SENDING: 'Sending',
    SENT: 'Sent',
    DRAFT: 'Draft',
    STOPPED: 'Stopped by user',
    FAILURE: 'Error',
};

export const SMS_BROADCAST_STATUS_MESSAGE_TYPE = {
    SCHEDULED: 'warning',
    SENDING: 'good',
    SENT: 'good',
    DRAFT: 'default',
    STOPPED: 'error',
    FAILURE: 'error',
};

export const SEND_NOW = 'sendNow';
export const SEND_LATER = 'sendLater';

export const SMS_OPT_STATUSES = {
    SINGLE_OPT_IN: 'SINGLE_OPT_IN',
    DOUBLE_OPT_IN: 'DOUBLE_OPT_IN',
    OPT_OUT: 'OPT_OUT',
    UNREACHABLE: 'UNREACHABLE',
    UNCONFIRMED: 'UNCONFIRMED',
    EXPIRED: 'EXPIRED',
};

export const CONSENT_ACQUISITION_KIND = {
    FORM: 'FORM',
    SMS: 'SMS',
    USER_REPORTED_CONSENT: 'USER_REPORTED_CONSENT',
    LANDING_PAGE: 'LANDING_PAGE',
};

export const MAX_RECIPIENTS = 500;

export const MAX_CHARACTER_COUNT = 160;

export const SMS_MESSAGE_LENGTH = {
    SHOW_WARNING: 300,
    SHOW_ERROR: 500,
    MAXIMUM: 1000,
};

export const SUPPORTED_MERGE_FIELDS = {
    '[[contact.first_name]]': 'Contact\'s first name',
};

export const DAYS_OF_WEEK = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    NEXT_MONDAY: 8,
};

// FS-39606: extended timeouts to prevent test failures when running in CircleCI
export const EXTENDED_TEST_TIMEOUTS = {
    SHORT_TIMEOUT: 10000,
    LONG_TIMEOUT: 20000,
};

export const KMN_VERIFICATION_STATUS_TYPE = {
    PENDING_SUBMISSION: 'PENDING_SUBMISSION',
    PENDING_VERIFICATION: 'PENDING_VERIFICATION',
    REJECTED: 'REJECTED',
    RESUBMISSION: 'RESUBMISSION',
    APPROVED: 'APPROVED',
    EXPIRED: 'EXPIRED',
    NOT_VERIFIED: 'NOT_VERIFIED',
};

export const PRE_20240130_SENDABLE_TOLL_FREE_SMS_STATUSES = [
    KMN_VERIFICATION_STATUS_TYPE.APPROVED,
    KMN_VERIFICATION_STATUS_TYPE.EXPIRED,
    KMN_VERIFICATION_STATUS_TYPE.NOT_VERIFIED,
    KMN_VERIFICATION_STATUS_TYPE.PENDING_SUBMISSION,
    KMN_VERIFICATION_STATUS_TYPE.PENDING_VERIFICATION,
    KMN_VERIFICATION_STATUS_TYPE.REJECTED,
    KMN_VERIFICATION_STATUS_TYPE.RESUBMISSION,
];

export const POST_20240130_SENDABLE_TOLL_FREE_SMS_STATUSES = [
    KMN_VERIFICATION_STATUS_TYPE.APPROVED,
];

export const POST_20240130_UNSENDABLE_TOLL_FREE_SMS_STATUSES = [
    KMN_VERIFICATION_STATUS_TYPE.EXPIRED,
    KMN_VERIFICATION_STATUS_TYPE.NOT_VERIFIED,
    KMN_VERIFICATION_STATUS_TYPE.PENDING_SUBMISSION,
    KMN_VERIFICATION_STATUS_TYPE.PENDING_VERIFICATION,
    KMN_VERIFICATION_STATUS_TYPE.REJECTED,
    KMN_VERIFICATION_STATUS_TYPE.RESUBMISSION,
];
